module.exports = __webpack_public_path__ + "static/DE-f1a26d9ea6529b93596f69a48752b3d6.jpg";